import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Info = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0626 3.37195C7.092 3.37195 3.06256 7.40139 3.06256 12.3719C3.06256 17.3425 7.092 21.3719 12.0626 21.3719C17.0331 21.3719 21.0626 17.3425 21.0626 12.3719C21.0626 7.40139 17.0331 3.37195 12.0626 3.37195ZM1.06256 12.3719C1.06256 6.29682 5.98743 1.37195 12.0626 1.37195C18.1377 1.37195 23.0626 6.29682 23.0626 12.3719C23.0626 18.4471 18.1377 23.3719 12.0626 23.3719C5.98743 23.3719 1.06256 18.4471 1.06256 12.3719ZM11.0626 8.37195C11.0626 7.81966 11.5103 7.37195 12.0626 7.37195H12.0726C12.6248 7.37195 13.0726 7.81966 13.0726 8.37195C13.0726 8.92423 12.6248 9.37195 12.0726 9.37195H12.0626C11.5103 9.37195 11.0626 8.92423 11.0626 8.37195ZM12.0626 11.3719C12.6148 11.3719 13.0626 11.8197 13.0626 12.3719V16.3719C13.0626 16.9242 12.6148 17.3719 12.0626 17.3719C11.5103 17.3719 11.0626 16.9242 11.0626 16.3719V12.3719C11.0626 11.8197 11.5103 11.3719 12.0626 11.3719Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
